import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const JobStreamUiContext = createContext(null);

export function JobStreamUiProvider({ children }) {
  const [uiByJobId, setUiByJobId] = useState({});

  const setJobStreamUi = useCallback((jobId, patch) => {
    if (!jobId) return;
    setUiByJobId((prev) => ({
      ...prev,
      [jobId]: { ...prev[jobId], ...patch },
    }));
  }, []);

  const clearJobStreamUi = useCallback((jobId) => {
    if (!jobId) return;
    setUiByJobId((prev) => {
      if (!prev[jobId]) return prev;
      const next = { ...prev };
      delete next[jobId];
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ uiByJobId, setJobStreamUi, clearJobStreamUi }),
    [uiByJobId, setJobStreamUi, clearJobStreamUi]
  );

  return (
    <JobStreamUiContext.Provider value={value}>
      {children}
    </JobStreamUiContext.Provider>
  );
}

export function useJobStreamUiReader(jobId) {
  const ctx = useContext(JobStreamUiContext);
  if (!ctx) return null;
  return ctx.uiByJobId[jobId] || null;
}

export function useJobStreamUiPublisher() {
  const ctx = useContext(JobStreamUiContext);
  return ctx?.setJobStreamUi ?? null;
}

export function useJobStreamUiClear() {
  const ctx = useContext(JobStreamUiContext);
  return ctx?.clearJobStreamUi ?? null;
}
